export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8609.458049d2.jpg";